import { useEffect, useRef, useState } from "react";

export function useThrottle(cb, interval = 500) {
  const lastRun = useRef(Date.now());
  
  return function () {
    if (Date.now() - lastRun.current >= interval) {
      cb(); // Execute the callback
      lastRun.current = Date.now(); // Update last execution time
    }
  };
}